import { render } from "./YouTubeCallback.vue?vue&type=template&id=8c1ad8b8&scoped=true&ts=true"
import script from "./YouTubeCallback.vue?vue&type=script&lang=ts"
export * from "./YouTubeCallback.vue?vue&type=script&lang=ts"

import "./YouTubeCallback.vue?vue&type=style&index=0&id=8c1ad8b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1ad8b8"]])

export default __exports__